import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import DonateModal from './DonateModal';

/**
 * FloatingDonateButton — persistent bottom-right CTA
 * Opens a modal/lightbox instead of navigating away.
 * Keeps the user on their current page.
 */
const FloatingDonateButton = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalFocusMerch, setModalFocusMerch] = useState(false);

  // Auto-collapse to icon-only on mobile after 5s
  useEffect(() => {
    const timer = setTimeout(() => {
      if (window.innerWidth < 640) setCollapsed(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  const openDonate = () => {
    setModalFocusMerch(false);
    setModalOpen(true);
  };

  const openMerch = () => {
    setModalFocusMerch(true);
    setModalOpen(true);
  };

  // Hide donate/merch FABs on owner-only screens (admin + agent dashboard)
  const HIDDEN_ROUTES = ['/wymrad32333', '/agent-dashboard'];
  if (HIDDEN_ROUTES.includes(location.pathname)) return null;

  return (
    <>
      {/* Stacked FABs — Donate on top, Merch below */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2.5">
        {/* Donate pill */}
        <button
          onClick={openDonate}
          className="group relative"
          title="Donate to keep transparency alive"
        >
          <div className={`flex items-center gap-2 bg-gradient-to-r from-emerald-500 to-cyan-600 text-white font-bold rounded-full shadow-lg hover:shadow-2xl hover:from-emerald-400 hover:to-cyan-500 transition-all duration-300 ${
            collapsed ? 'px-3 py-3' : 'px-5 py-3'
          }`}>
            <Icon name="Heart" size={18} className="animate-pulse" />
            {!collapsed && <span className="text-sm hidden sm:inline">Donate</span>}
          </div>
          {/* Subtle ping animation */}
          <span className="absolute -top-1 -right-1 flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-emerald-500"></span>
          </span>
        </button>

        {/* Merch pill — opens modal focused on merch */}
        <button
          onClick={openMerch}
          className="group"
          title="Browse merch store"
        >
          <div className={`flex items-center gap-2 bg-gradient-to-r from-amber-500 to-orange-600 text-white font-bold rounded-full shadow-lg hover:shadow-2xl hover:from-amber-400 hover:to-orange-500 transition-all duration-300 ${
            collapsed ? 'px-3 py-3' : 'px-5 py-3'
          }`}>
            <Icon name="ShoppingBag" size={18} />
            {!collapsed && <span className="text-sm hidden sm:inline">Merch</span>}
          </div>
        </button>
      </div>

      <DonateModal isOpen={modalOpen} onClose={() => setModalOpen(false)} focusMerch={modalFocusMerch} />
    </>
  );
};

export default FloatingDonateButton;
